class BsBundle {
  constructor(container) {
    this.container = container;
    this.cards = container.querySelectorAll('.bs-bundle__card');
    this.variantInput = container.querySelector('[name="id"]');
    this.priceEl = container.querySelector('.bs-hero__price-main');
    this.comparePriceEl = container.querySelector('.bs-hero__price-compare');
    this.saveBadgeEl = container.querySelector('.bs-hero__save-badge');
    this.atcBtn = container.querySelector('.bs-atc-btn');
    this.atcBtnText = container.querySelector('.bs-atc-btn__text');
    this.init();
  }

  init() {
    this.cards.forEach(card => {
      card.addEventListener('click', () => this.select(card));
      card.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.select(card);
        }
      });
    });
    // Activate first card on load
    if (this.cards.length) this.select(this.cards[0]);
  }

  select(card) {
    this.cards.forEach(c => {
      c.classList.remove('bs-bundle__card--active');
      c.setAttribute('aria-checked', 'false');
    });
    card.classList.add('bs-bundle__card--active');
    card.setAttribute('aria-checked', 'true');

    const variantId = card.dataset.variantId;
    const price = parseInt(card.dataset.price);
    const comparePrice = parseInt(card.dataset.comparePrice || 0);
    const label = card.dataset.label;

    if (this.variantInput && variantId) {
      this.variantInput.value = variantId;
    }

    if (this.priceEl) {
      this.priceEl.textContent = this.formatMoney(price);
    }

    if (this.comparePriceEl) {
      if (comparePrice && comparePrice > price) {
        this.comparePriceEl.textContent = this.formatMoney(comparePrice);
        this.comparePriceEl.style.display = 'inline';
      } else {
        this.comparePriceEl.style.display = 'none';
      }
    }

    if (this.saveBadgeEl) {
      if (comparePrice && comparePrice > price) {
        const pct = Math.round((1 - price / comparePrice) * 100);
        this.saveBadgeEl.textContent = 'Save ' + pct + '%';
        this.saveBadgeEl.style.display = 'inline';
      } else {
        this.saveBadgeEl.style.display = 'none';
      }
    }

    if (this.atcBtnText) {
      this.atcBtnText.textContent = 'ADD TO CART — ' + this.formatMoney(price);
    }

    // Sync mobile cart bar
    const mobileBar = document.querySelector('.bs-mobile-bar');
    if (mobileBar) {
      const mobilePrice = mobileBar.querySelector('.bs-mobile-bar__price');
      if (mobilePrice) mobilePrice.textContent = this.formatMoney(price);
    }
  }

  formatMoney(cents) {
    return '$' + (cents / 100).toFixed(0);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.bs-hero__form').forEach(form => {
    new BsBundle(form);
  });
});
